<script lang="ts">
	import { Box } from '@wiseed/wikit';
	import { t } from 'svelte-i18n';
	import { Social } from '@wiseed/wikit';
	import { capitalize } from '@wiseed/wikit';
	import type { WSSocialShareType } from '@wiseed/wikit';
	import type { OperationModel } from '@app/models/api/OperationModel';
	import { onMount } from 'svelte';

	export let operation: OperationModel;
	let socialItems: WSSocialShareType[];

	const getPostTitle = () => {
		return `Retrouvez ${operation.name} sur WiSEED`;
	};

	const getTwitterLink = () => {
		return new URL(`https://twitter.com/share?url=${window.location.href}&text=${getPostTitle()}`)
			.href;
	};

	const getFacebookLink = () => {
		let title = `${window.location.host}+${getPostTitle()}`;
		return new URL(
			`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&t=${title}`
		).href;
	};

	const getLinkedInLink = () => {
		return new URL(
			`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
				window.location.href
			)}`
		).href;
	};

	onMount(() => {
		socialItems = [
			{
				iconName: 'linkedin',
				url: getLinkedInLink()
			},
			{
				iconName: 'twitter',
				url: getTwitterLink()
			},
			{
				iconName: 'facebook',
				url: getFacebookLink()
			}
		];
	});
</script>

<Box props={{ classNames: 'border border-grey-light space-y-3' }}>
	<div class="font-semibold">{capitalize($t('operation.share'))}</div>
	<div class="flex gap-2">
		<Social items={socialItems} />
	</div>
</Box>
